module.exports = __webpack_public_path__ + "res/15-img_timer.d8ee39de464fc14690fd8018cf63ad50.png";